/** Backend-aligned client limits (validate before upload / submit). */

export const PINE_SCRIPT_MAX_CHARS = 200_000;

export const CSV_IMPORT_MAX_BYTES = 5 * 1024 * 1024; // 5 MB

/** POST /v1/trade-policy/simulate — max concurrent jobs per user. */
export const MAX_SIMULATE_INFLIGHT = 2;

export const PINE_SCRIPT_MAX_CHARS_MESSAGE =
  "Pine script must be 200,000 characters or fewer.";

export function csvImportMaxSizeMessage(maxMb = 5): string {
  return `File must be ${maxMb} MB or smaller.`;
}

export function isPineScriptWithinLimit(script: string): boolean {
  return script.length <= PINE_SCRIPT_MAX_CHARS;
}

export function isCsvImportFileWithinLimit(file: File): boolean {
  return file.size <= CSV_IMPORT_MAX_BYTES;
}
